import PropTypes from "prop-types";
import classNames from "classnames/bind";
import styles from "./WareHouse.module.css";
import RenderStatus from "../../../components/StatusRender";

const cx = classNames.bind(styles);
const Camera = ({ name, status, message ,index}) => {
  const companyCode = sessionStorage.getItem('company_code');
  return (
    <div className={cx("item-cam")}>
      <div className={cx("camera")}>
        <span className={cx("On")}>
            <RenderStatus companyCode={companyCode} status={status} />
            <p className={cx('tooltip',index === 0 ?'bottom':"top")}>
              {message}
            </p>
        </span>
        <span className={cx("name")}>{name}</span>
      </div>
    </div>
  );
};
Camera.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  check: PropTypes.bool.isRequired,
  camID: PropTypes.string.isRequired,
  prioritized: PropTypes.string

};
export default Camera;
